import crudHandlers from "./_crud";

export default (state, action) => {
    const { type } = action;
    switch (type) {
        case `ADD_BRANCH_BILL_OF_LADING`:
            state = crudHandlers(state, action, 'branch_bill_of_lading')
            return state

        default:

            state = crudHandlers(state, action, 'branch_bill_of_lading')
            return state
    }
}